<!-- <form class="max-w-sm mx-auto" [formGroup]="form" (ngSubmit)="onSubmit()"> -->
<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <!-- <div class="flex items-center mt-2"> -->

  <div
    class="flex flex-row flex-wrap md:flex-nowrap h-10 border border-gray-300 text-gray-900 text-sm rounded-full has-[:focus]:ring-primary-600 has-[:focus]:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:has-[:focus]:ring-blue-500 dark:has-[:focus]:border-blue-500"
  >
  <div class="flex flex-nowrap flex-grow w-full md:w-auto">
    <button
      *ngIf="enableCountry"
      id="dropdown-phone-button"
      data-dropdown-toggle="dropdown-phone"
      class="flex items-center justify-around z-10 px-4 text-sm font-medium text-center rounded-full focus:ring-0 focus:outline-none"
      type="button"
      [disabled]="!(form.controls.country?.enabled ?? false)"
      [class]="
        form.controls.country?.enabled ?? false
          ? buttonClasses.dropdown.enabled
          : buttonClasses.dropdown.disabled
      "
    >
      <svg
        aria-hidden="true"
        role="status"
        class="inline w-4 h-5 me-3 text-white animate-spin"
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        *ngIf="isCountryListLoading"
      >
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="#E5E7EB"
        />
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="currentColor"
        />
      </svg>

      <ng-template ngIf="!isCountryListLoading">
        {{ this.form.controls.country?.value?.idd ?? '' }}
        <svg
          class="w-2.5 h-5 ms-2.5"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 10 6"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="m1 1 4 4 4-4"
          />
        </svg>
      </ng-template>
    </button>

    <div
      id="dropdown-phone"
      class="hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-52 dark:bg-gray-700 z-20"
    >
      <ul
        class="py-2 text-sm text-gray-700 dark:text-gray-200"
        aria-labelledby="dropdown-phone-button"
      >
        <li *ngFor="let country of countryList">
          <button
            type="button"
            class="inline-flex w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-600 dark:hover:text-white"
            role="menuitem"
            (click)="onMenuClick(country)"
          >
            <ng-container
              [ngTemplateOutlet]="dropdownMenuItem"
              [ngTemplateOutletContext]="{ country: country }"
            ></ng-container>
          </button>
        </li>
      </ul>
    </div>

    <!-- <label
      for="phone-input"
      class="text-sm font-medium sr-only text-gray-900 dark:text-white"
      >{{ 'Phone Number' | translate }}</label
    > -->

    <input
      type="text"
      id="phone-input"
      class="flex-grow min-w-0 px-2.5 border-none focus:outline-none focus:ring-0 bg-transparent"
      pattern=""
      placeholder="{{ 'Phone Number' | translate }}"
      formControlName="phone"
      autocomplete="off"
      [mask]="form.controls.country?.value?.mask ?? '0*'"
      [class]="inputClasses"
    />
  </div>

    <div
      class="flex justify-around items-center z-10 px-4 py-2.5 text-sm font-medium text-center text-white rounded-full focus:ring-0 focus:outline-none w-full md:w-auto"
      [class]="suffixButtonClasses"
    >
      <button
        *ngIf="!isSubmitting"
        id="submit-button"
        type="submit"
        [disabled]="disabled || !isFormValid()"
      >
        <ng-container [ngTemplateOutlet]="submitButton"></ng-container>
      </button>

      <ng-container
        *ngIf="!isSubmitting"
        [ngTemplateOutlet]="verifiedStatus"
      ></ng-container>

      <ng-container *ngIf="isSubmitting">
        <!-- <div class="w-2"></div> -->
        <flowbite-loading size="1.25rem"></flowbite-loading>
      </ng-container>
    </div>
  </div>
  <p class="mt-[2.5rem] md:mt-1 text-xs text-red-600 dark:text-red-500" *ngIf="errorMessage">
    {{ errorMessage }}
  </p>
</form>
